<template lang="pug">
    v-card.style-html(dark style="border-radius:8px;overflow:hidden;")
        v-card-title.pa-3.title.white--text.xs-center.text-xs-center Obtener usuario y contraseña
            //-p.title.white--text.xs-center Obtener usuario y contraseña
        v-divider
        v-card-text
            //-v-flex(xs12,md12,v-if="computedCargo")
            v-layout(row,wrap)
                v-flex(xs12,md12 v-if="email!=null")
                    | Usuario: <span style="color:#70ff86"> {{email}} </span>
                v-flex(xs12,md12 v-if="email!=null")
                    |Contraseña: <span style="color:#70ff86"> {{fechaNacimiento}} </span>
                v-flex.mt-4(xs12,md12)
                    v-text-field(label="INGRESE NUMERO DE CARNET:" color="success"
                        v-model="numeroDocumento" v-on:keyup.enter="buscar" hide-details outlined)
        v-divider
        v-card-actions
            v-btn(@click="onCancelar" color="red" dark)
                | Cerrar
            v-spacer
            v-btn(@click="buscar" color="blue" dark :loading="isLoading")
                | Buscar
</template>


<script>
module.exports = {
    props: {
        onCancelar: {
            type: Function
        }
    },
    data: function() {
        return {
            numeroDocumento: null,
            email: null,
            fechaNacimiento: null,
            isLoading: false,
        };
    },
    methods: {
        buscar: function() {
            this.isLoading = true;
            if (this.numeroDocumento === null || this.numeroDocumento === "" || typeof this.numeroDocumento === "undefined") {
                this.$snotify.error("Debe ingresar su C.I.");
                this.isLoading = false;
                return;
            }
            return axios({
                method: 'get',
                url: '/app/app-abms/api/v1/servicio_app_abms/usuario/vistaObtenerUsuario/' + this.numeroDocumento
            }).then((function(response) {
                this.isLoading = false;
                if ((response.data.status = 201 && response.data.email !== null)) {
                    this.email = response.data.email;
                    return this.fechaNacimiento = response.data.fechaNacimiento;
                } else {
                    return this.$snotify.error("No se encontro ningun registro con el criterio proporcionado.");
                }
            }).bind(this))["catch"]((function(error) {
                this.isLoading = false;
                //return console.log(error);
                return this.$snotify.error("No se obtuvo ninguna respuesta.");
            }).bind(this));
        }
    }
};
</script>